import { render } from "./OrderForm.vue?vue&type=template&id=17acc8af&scoped=true"
import script from "./OrderForm.vue?vue&type=script&lang=js"
export * from "./OrderForm.vue?vue&type=script&lang=js"

import "./OrderForm.vue?vue&type=style&index=0&id=17acc8af&scoped=true&lang=css"

import exportComponent from "/home/jacques/development/kvhbf/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17acc8af"]])

export default __exports__